import useDashboardEditor from "MyDashboards/state/editor";
import { Element, Slide } from "MyDashboards/state/editorTypes";
import React from "react";

import { scaledPx } from "MyDashboards/utils/px";
import * as CSS from "csstype";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { getFileApiURL as fileURLToPath } from "qpr-base/utils/url-utils";
import { TDashboardComponentRegistry } from "../ComponentRegistry/types";

const RenderSelectedSlide = (props: {
  slide?: Slide;
  width?: number;
  containerStyle?: CSS.Properties;
  containerClass?: string;
  RenderElement: React.FunctionComponent<{ el: Element }>;
  registry: TDashboardComponentRegistry;
  onClick?: () => void;
}) => {
  const editorWidth = useDashboardEditor((e) => e.editorWidth);
  const selectedElementId = useDashboardEditor((s) => s.selectedElementId);
  const selectedElements = useDashboardEditor((s) => s.selectedElements);
  const selectedPageId = useDashboardEditor((s) => s.selectedPageId);
  const setActiveElement = useDashboardEditor((s) => s.setSelectedElement);
  const editedElement = useDashboardEditor((s) => s.editedElement);
  const { RenderElement, containerStyle } = props;
  const ctx = useAppContext();
  const isDragged = React.useCallback(
    (id: string) => {
      if (id === selectedElementId) return true;
      return selectedElements.includes(id);
    },
    [selectedElementId, selectedElements]
  );
  const selectedSlide = useDashboardEditor((s) => {
    if (props.slide) {
      return props.slide;
    }
    const [page] = s.pages.filter((p) => p.id === s.selectedPageId);
    if (page) {
      return page;
    }
  });

  const px = scaledPx(1);

  return (
    <div
      style={{ position: "relative", ...(containerStyle || {}) }}
      className={props.containerClass}
    >
      <div
        onClick={props.onClick}
        id={selectedPageId}
        style={{
          backgroundImage: selectedSlide
            ? `url(${fileURLToPath(`/cache/${selectedSlide.bgPngRef}.png`)}`
            : "",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          // transform: 'scale(0.5)',
          transformOrigin: `${ctx.rtl ? "right" : "left"} top`,
          width: px(selectedSlide?.width || 0),
          height: px(selectedSlide?.height || 0),
          position: "absolute",
          overflow: "hidden",
          transform: props.width
            ? `scale(${props.width / editorWidth})`
            : "none",
        }}
        role="button"
        tabIndex={0}
        onKeyDown={() => {}}
      >
        {selectedSlide
          ? selectedSlide.elements.map((el) => {
              let renderStyleParams: CSS.Properties = {
                position: "absolute",
                left: px(el.x),
                top: px(el.y),
                width: px(el.width),
                height: px(el.height),
              };
              const addStyle = (params: CSS.Properties) => {
                renderStyleParams = { ...renderStyleParams, ...params };
              };

              if (el.rendered?.pngRef) {
                addStyle({
                  backgroundImage: el.component
                    ? undefined
                    : `url(${fileURLToPath(`/cache/${el.rendered.pngRef}`)}`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  border: isDragged(el.id) ? "0px dashed gray" : undefined,
                });
              }
              //                   <RenderElement el={el} />

              return (
                <div
                  id={`rendered_${el.id}`}
                  style={renderStyleParams}
                  key={el.id}
                >
                  <props.registry.Render el={el} />
                </div>
              );
            })
          : null}
      </div>
    </div>
  );
  /**
   * If you want to debug the editedElement action
   */
  //       <pre style={{ marginTop: '100px' }}>{JSON.stringify(editedElement, null, 2)}</pre>
};

export default RenderSelectedSlide;
